import { MaterialIcons } from "@expo/vector-icons";
import { Button, useTheme, VStack } from "native-base";
import React from "react";
import { useTranslation } from "react-i18next";

import { FeatureFlag as FeatureFlagProper, isFeatureFlagActive } from "../helpers/featureFlags";
import type { User } from "../services/backendTypes";

interface CopyMealsToCurrentDayButtonProps {
  hasMealsPlanned: boolean;
  hasRecipeMealsPlanned: boolean;
  user: User | null;
  onOpenCopyDay: () => void;
}

const CopyMealsToAnotherDayButton = ({
  hasMealsPlanned,
  hasRecipeMealsPlanned,
  user,
  onOpenCopyDay,
}: CopyMealsToCurrentDayButtonProps): JSX.Element | null => {
  const { t } = useTranslation();
  const theme = useTheme();

  // Don't show the button if:
  // 1. User is not set
  // 2. Feature flag is not active
  // 3. Current day already has meals planned
  if (!user || !isFeatureFlagActive(user, FeatureFlagProper.FF_COPY_MEALS_TO_ANOTHER_DAY) || !hasMealsPlanned) {
    return null;
  }

  return (
    <VStack alignItems="center" px={2} py={2}>
      <Button
        onPress={onOpenCopyDay}
        testID="copy-current-day-button"
        leftIcon={<MaterialIcons name="content-copy" size={20} color={theme.colors.function[10]} />}
        size="lg"
        borderRadius={theme.borderRadii.button.large}
        backgroundColor="primary.50"
        _pressed={{ backgroundColor: "primary.50" }}
        borderWidth={1}
        borderColor="primary.50"
        _text={{
          color: "function.10",
          fontWeight: "600",
          fontSize: "md",
        }}
        px={5}
        py={2.5}
        width="100%"
      >
        {t("planner.copy_day.copy_to_another_day_button_text")}
      </Button>
    </VStack>
  );
};

export default CopyMealsToAnotherDayButton;
